import { FC } from "react";
import { Popover } from "@mui/material";
import { useDidMount } from "rooks";
import Stack from "@mui/material/Stack";
import { FilterTreeNodeWithId } from "@/components/pages/common/filters-tree/utils/types/common";
import { getDimensionsThunk } from "@/store/dimensions/thunks/dimensions/getDimensionsThunk";
import { useAppDispatch } from "@/store/hooks";
import { useMenuHook } from "@/utils/hooks/useMenu.hook";
import { BillingExplorerFilterTreeAddToDimensionButton } from "@/components/pages/resource-explorer/components/app-bar/components/resource-explorer-toolbar/components/add-filter-tree-to-dimension/BillingExplorerFilterTreeAddToDimensionButton";
import { BillingExplorerFilterTreeAddToDimensionPopover } from "@/components/pages/resource-explorer/components/app-bar/components/resource-explorer-toolbar/components/add-filter-tree-to-dimension/BillingExplorerFilterTreeAddToDimensionPopover";

interface BillingExplorerFilterTreeAddToDimensionListProps {
  filterTree?: FilterTreeNodeWithId;
}

export const BillingExplorerFilterTreeAddToDimensionList: FC<
  BillingExplorerFilterTreeAddToDimensionListProps
> = ({ filterTree }) => {
  const { anchor, open, openMenu, closeMenu } = useMenuHook();
  const dispatch = useAppDispatch();

  useDidMount(() => {
    dispatch(getDimensionsThunk());
  });

  return (
    <Stack>
      <BillingExplorerFilterTreeAddToDimensionButton
        open={open}
        openMenu={openMenu}
        filterTree={filterTree}
      />
      <Popover
        open={open}
        anchorEl={anchor}
        onClose={closeMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        slotProps={slotProps}
        disablePortal
      >
        <BillingExplorerFilterTreeAddToDimensionPopover
          filterTree={filterTree}
          onClose={closeMenu}
        />
      </Popover>
    </Stack>
  );
};

const slotProps = {
  paper: {
    sx: {
      maxWidth: 500,
    },
  },
};
